import type { OutreachStep } from '../types';

/**
 * Convert generated message HTML into readable plain text while preserving
 * paragraph and line-break structure for display and clipboard use.
 */
export const messageHtmlToPlainText = (value: unknown): string => {
    if (typeof value !== 'string') return '';

    return value
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>\s*/gi, '\n\n')
        .replace(/<p[^>]*>/gi, '')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/\n{3,}/g, '\n\n')
        .split('\n')
        .map((line) => line.trimEnd())
        .join('\n')
        .trim();
};

export const hasOutreachMessageBody = (step: Pick<OutreachStep, 'body'>): boolean => (
    messageHtmlToPlainText(step.body).length > 0
);
